import { Component } from '@angular/core';

@Component({
  selector: 'uni-layout-content',
  templateUrl: './uni-layout-content.component.html',
  styleUrls: ['./uni-layout-content.component.scss'],
})
export class UniLayoutContentComponent { }
